module.exports = __webpack_public_path__ + "static/media/item_bg.8745ac58.png";